import React, { useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { useSelector } from "react-redux";
import "../custom.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Paper,
  Typography,
  Button,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
} from "@mui/material";
import AddCandidateDrawer from "../components/addCandidateDrawer";
import SearchIcon from "@mui/icons-material/Search";
import AdvanceFilter from "../components/advanceFilter";
import { generate_filter_condition } from "../utiles/filter";
import Cookies from "js-cookie";
import AddToJobBtn from "../components/addToJobBtn";
import NewAddCandidate from "../components/NewAddCandidate";
import AddBulkCandidates from "../components/AddBulkCandidates";
import DynamicDataGrid from "../components/dynamicDataGrid";

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: "none",
  padding: theme.spacing(1),
}));

function ManageCandidate({
  pollStatus,
  setUploadProgress,
  setUploadingFiles,
  setUploadPanelOpen,
  setProcessedFiles,
  isProcessing,
  setIsProcessing,
}) {
  const PermissionStatus = useSelector((state) => state.user.permissions);
  const addCandidatePermission = PermissionStatus["100"];
  const [newCount, setNewCount] = useState(0);
  const [quesAnsArrayFilter, setQuesAnsArrayFilter] = useState([]);
  const [current, setCurrent] = useState([]);
  const [onrowClick, setOnRowClick] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [sortModel, setSortModel] = useState([
    { field: "date_created", sort: "desc" },
  ]);
  const [isReset, setIsReset] = useState(false);
  const [selectedCount, setSelectedCount] = useState(0);
  const [FilterHitting, setFilterHitting] = useState(false);
  const [newData, setNewData] = useState([]);
  const [createdby, setCreatedby] = useState("");
  const [checkboxValues, setCheckboxValues] = useState({});
  const [cancelData, setCancelData] = useState(false);
  const [question, setQuestion] = useState([]);
  const [refreshagain, setrefreshagain] = useState(false);
  const [ManageCandidates, setManageCandidates] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [candidateList, setCandidateList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [textFields, setTextFields] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchTermPrev, setSearchTermPrev] = useState("");
  const [advanceFilter, setAdvanceFilter] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [radioValues, setRadioValues] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [operatorValues, setOperatorValues] = useState({});
  const [checkedCount, setCheckedCount] = useState(0);
  const [username, setUsername] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [filterOptions, filtersetQueryOptions] = React.useState({
    filterModel: null,
  });
  const [warning, setWarning] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openAddtoJob, setOpenAddtoJob] = useState(false);
  const [addToJobCandidateids, setAddToJobCandidateids] = useState([]);
  const [isBulkUpload, setIsBulkUpload] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const dropdownOpen = Boolean(anchorEl);

  const newCandidateRef = useRef(null);
  const bulkCandidateRef = useRef(null);

  const handleBulkUploadChange = (event) =>
    setIsBulkUpload(event.target.checked ? 1 : 0);

  const [paginationModel, setPaginationModel] = useState({
    page: Number(searchParams.get("page")) - 1 || 0,
    pageSize: 10,
  });
  const containerRef = React.useRef(null);
  const [queryOptions, setQueryOptions] = useState({});
  const nav = useNavigate();
  const viewCandidateFlag = 1;
  const [renderKey, setRenderKey] = useState(0);

  const radioNames = [
    "All Candidates",
    "Associated With Job",
    "Not Associated With Job",
  ];
  const [selectedViewName, setSelectedViewName] = useState(radioNames[0]);
  const [isRadioChange, setIsRadioChange] = useState(false);

  const handleViewCandidateBy = (event) => {
    setSelectedViewName(event.target.value);
    sessionStorage.setItem("selectedViewName", event.target.value);
    setIsRadioChange(true);
  };

  const getUserData = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const candidateOwnerList = await axios.get(`active-users/${user_id}`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });
      setCandidateList(candidateOwnerList.data.message);
      setUsername("Select User Name");
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const handleBulkUploadComplete = () => setrefreshagain((prev) => !prev);
    window.addEventListener("bulkUploadComplete", handleBulkUploadComplete);
    return () =>
      window.removeEventListener(
        "bulkUploadComplete",
        handleBulkUploadComplete,
      );
  }, []);

  useEffect(() => {
    if (advanceFilter === true) getUserData();
  }, [advanceFilter]);

  const handleRowSelection = (newSelection) => {
    const deselectedRows = selectedRows.filter(
      (id) => !newSelection.includes(id),
    );
    const currentSelectionCount = selectedRows.length - deselectedRows.length;
    const validNewSelections = newSelection.filter(
      (id) => !selectedRows.includes(id),
    );
    const canSelectMore = 10 - currentSelectionCount;
    const limitedNewSelections = validNewSelections.slice(0, canSelectMore);
    const updatedSelection = [
      ...selectedRows.filter((id) => !deselectedRows.includes(id)),
      ...limitedNewSelections,
    ];
    if (validNewSelections.length > limitedNewSelections.length) {
      setWarning(true);
      if (containerRef.current)
        containerRef.current.scrollIntoView({ top: 0, behavior: "smooth" });
    }
    setSelectedRows(updatedSelection);
    setAddToJobCandidateids(updatedSelection);
  };

  const HandleRowClick = (row) => {
    const currentUrl = window.location.href;
    sessionStorage.setItem("manageCandidatepreviousUrl", currentUrl);
    setOnRowClick(true);
    nav(`/Manage-Candidates/${row.id}`, {});
  };

  const validate = () => {
    let isValid = true;
    let updateArray = [...quesAnsArrayFilter];
    updateArray.forEach((item) => {
      if (item.type_id === 2 && item.isChecked) {
        if (item.ans_text === "") {
          item.errorText = "This field is required";
          isValid = false;
        } else if (item.ans_text.length > 12) {
          item.errorText = "Maximum 12 digits allowed";
          isValid = false;
        } else item.errorText = null;
      } else if (item.type_id === 3 && item.isChecked) {
        if (item.ans_text === "") {
          item.errorText = "Please select an option";
          isValid = false;
        } else item.errorText = null;
      } else item.errorText = null;
    });
    setQuesAnsArrayFilter(updateArray);
    return isValid;
  };

  const listofCandidatesApi = async () => {
    setShowLoader(true);
    const selectedViewName = sessionStorage.getItem("selectedViewNameApplied");
    const index = radioNames.indexOf(selectedViewName);
    const selectedViewNameIndex =
      index !== -1 ? index : selectedViewName ? selectedViewName : 0;
    const createdByApplied = sessionStorage.getItem("createdbyApplied");
    let payload = {
      filterCriteria: createdByApplied !== null ? createdByApplied : "",
      viewCandidatesBy: selectedViewNameIndex,
      pageSize: queryOptions?.pageSize || 10,
      isBulkUpload,
    };
    if (queryOptions?.sortModel?.length > 0) {
      payload.sortField = queryOptions.sortModel[0].field;
      payload.sortBy = queryOptions.sortModel[0].sort;
    }
    const params = new URLSearchParams(window.location.search);
    const page = params.get("page") || 1;
    const searchQueryParam = params.get("search") || "";
    let apiUrl = `manage-candidates/${page}`;
    if (searchQueryParam)
      apiUrl += `?search=${encodeURIComponent(searchQueryParam)}`;
    try {
      const response = await axios.post(apiUrl, payload, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });
      const filteredApplicants = response.data.message.data.filter(
        (a) => a.id !== null,
      );
      setManageCandidates(filteredApplicants);
      setSearchTermPrev(searchTerm);
      setTotalCount(response.data.message.page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (error) {
      console.error("Error:", error);
      setrefreshagain(false);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    const query = searchParams.get("search") || "";
    setSearchQuery(decodeURIComponent(query));
  }, [searchParams]);

  useEffect(() => {
    const timer = setTimeout(() => {
      listofCandidatesApi();
    }, 500);
    return () => clearTimeout(timer);
  }, [queryOptions, paginationModel, refreshagain, searchQuery]);

  const handleSortModelChange = React.useCallback(
    (newSortModel) => {
      setSortModel(newSortModel);

      setQueryOptions((prev) => ({
        ...prev,
        sortModel: newSortModel,
      }));

      setPaginationModel((prev) => ({ ...prev, page: 0 }));
      setSearchParams({ page: 1, search: searchQuery });
    },
    [searchQuery],
  );

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    setSearchParams((prev) => ({ ...prev, search: query, page: 1 }));
  };

  const handleSelectionData = (event, value, reason) => {
    setSelectedOptions(value);
    setSelectedCount(value?.length);
    sessionStorage.setItem("selectedOptions", JSON.stringify(value));
    sessionStorage.setItem("selectedCount", value?.length);
    const usernames = value?.map((item) => item.name);
    const filterCondition = generate_filter_condition(
      "and concat(u.first_name, ' ', u.last_name)",
      "isAnyOf",
      usernames,
    );
    if (usernames?.length > 0) {
      setCreatedby(filterCondition);
      sessionStorage.setItem("createdby", filterCondition);
    } else {
      setCreatedby("");
      sessionStorage.removeItem("createdby");
    }
    if (reason === "clear") {
      setCreatedby("");
      sessionStorage.removeItem("createdby");
      setCancelData(true);
      setOpen(true);
    }
    if (reason === "removeOption") {
      setCancelData(true);
      setOpen(true);
    }
  };

  const handleAdvanceFilterOpen = () => {
    setNewData(selectedOptions);
    let mytemp = current.map((q) => ({ ...q }));
    const updatedValues = {},
      updatedText = {},
      updatedRadioValues = {},
      updatedOperator = {};
    mytemp.forEach((question) => {
      updatedText[question.question_id] = question.ans_text;
      updatedRadioValues[question.question_id] = question.ans_text;
      updatedOperator[question.question_id] = question.operator;
      if (question.isChecked !== undefined)
        updatedValues[question.question_id] = question.isChecked;
    });
    setOperatorValues((prev) => ({ ...prev, ...updatedOperator }));
    setRadioValues((prev) => ({ ...prev, ...updatedRadioValues }));
    setTextFields((prev) => ({ ...prev, ...updatedText }));
    setCheckboxValues((prev) => ({ ...prev, ...updatedValues }));
    setQuesAnsArrayFilter([...mytemp]);
    if (cancelData) setSelectedCount(newData?.length);
    setAdvanceFilter(true);
    setrefreshagain(false);
  };

  const handleAdvanceFilterClose = () => {
    setAdvanceFilter(false);
    setOpen(true);
    setFilterHitting(true);
    setIsBulkUpload(0);
    const updatedSelectedOptions =
      selectedOptions?.length > 0 || cancelData ? newData : [];
    setSelectedOptions(updatedSelectedOptions);
    setrefreshagain(false);
    const selectedViewNameApplied = sessionStorage.getItem(
      "selectedViewNameApplied",
    );
    const selectedcurrent = sessionStorage.getItem("selectedViewName");
    const selectedOptionsApplied = sessionStorage.getItem(
      "selectedOptionsApplied",
    );
    const selectedoptionCurrent = sessionStorage.getItem("selectedOptions");
    const selectedCountApplied = sessionStorage.getItem("selectedCountApplied");
    const selectedCountCurrent = sessionStorage.getItem("selectedCount");
    const createdbyApplied = sessionStorage.getItem("createdbyApplied");
    const createdbyCurrent = sessionStorage.getItem("createdby");
    if (
      selectedViewNameApplied === null ||
      selectedOptionsApplied === null ||
      selectedCountApplied === null ||
      createdbyApplied === null
    ) {
      sessionStorage.setItem("selectedViewName", radioNames[0]);
      setSelectedViewName(radioNames[0]);
      sessionStorage.setItem(
        "selectedOptions",
        JSON.stringify(updatedSelectedOptions),
      );
      sessionStorage.setItem("selectedCount", updatedSelectedOptions?.length);
      const usernames = updatedSelectedOptions?.map((item) => item.name) || [];
      const filterCondition =
        usernames.length === 0
          ? ""
          : generate_filter_condition(
              "and concat(u.first_name, ' ', u.last_name)",
              "isAnyOf",
              usernames,
            );
      sessionStorage.setItem("createdby", filterCondition);
    } else if (
      selectedViewNameApplied !== selectedcurrent ||
      selectedOptionsApplied !== selectedoptionCurrent ||
      selectedCountApplied !== selectedCountCurrent ||
      createdbyApplied !== createdbyCurrent
    ) {
      sessionStorage.setItem("selectedViewName", selectedViewNameApplied);
      setSelectedViewName(selectedViewNameApplied);
      sessionStorage.setItem("selectedOptions", selectedOptionsApplied);
      sessionStorage.setItem("selectedCount", selectedCountApplied);
      sessionStorage.setItem("createdby", createdbyApplied);
    }
    setIsRadioChange(false);
    setShowLoader(false);
  };

  useEffect(() => {
    const selectedViewNameApplied = sessionStorage.getItem(
      "selectedViewNameApplied",
    );
    if (selectedViewNameApplied === null) {
      sessionStorage.setItem("selectedViewName", radioNames[0]);
      setSelectedViewName(radioNames[0]);
      sessionStorage.removeItem("selectedOptions");
      sessionStorage.removeItem("selectedCount");
      sessionStorage.removeItem("createdby");
    } else {
      sessionStorage.setItem("selectedViewName", selectedViewNameApplied);
      setSelectedViewName(selectedViewNameApplied);
      sessionStorage.setItem(
        "selectedOptions",
        sessionStorage.getItem("selectedOptionsApplied"),
      );
      sessionStorage.setItem(
        "selectedCount",
        sessionStorage.getItem("selectedCountApplied"),
      );
      sessionStorage.setItem(
        "createdby",
        sessionStorage.getItem("createdbyApplied"),
      );
    }
  }, []);

  const handleAdvanceFilterApply = () => {
    setrefreshagain(true);
    setAdvanceFilter(!validate());
    const svn = sessionStorage.getItem("selectedViewName") || radioNames[0];
    sessionStorage.setItem("selectedViewNameApplied", svn);
    const selectedOptions = sessionStorage.getItem("selectedOptions");
    const selectedCount = sessionStorage.getItem("selectedCount");
    const createdBy = sessionStorage.getItem("createdby");
    if (selectedOptions && JSON.parse(selectedOptions).length > 0) {
      sessionStorage.setItem("selectedOptionsApplied", selectedOptions);
      sessionStorage.setItem("selectedCountApplied", selectedCount);
      sessionStorage.setItem("createdbyApplied", createdBy || "");
    } else {
      sessionStorage.removeItem("selectedOptionsApplied");
      sessionStorage.setItem("selectedCountApplied", 0);
      sessionStorage.removeItem("createdbyApplied");
    }
    let error = 0;
    let updateArray = [...quesAnsArrayFilter];
    updateArray.forEach((item) => {
      if (item.isChecked) {
        if (item.type_id === 2 && item.ans_text === "") {
          error = 1;
          item.errorText = "This field is required";
        } else if (item.type_id === 3 && item.ans_text === "") {
          error = 1;
          item.errorText = "Please select an option";
        }
      }
    });
    if (!error) {
      let mytemp = quesAnsArrayFilter.map((q) => ({ ...q }));
      const countChecked = mytemp.filter((item) => item.isChecked).length;
      setCheckedCount(countChecked);
      setNewCount(selectedCount > 0 ? countChecked + 1 : countChecked);
      setCurrent([...mytemp]);
      setFilterHitting(true);
      setOpen(true);
      setSearchParams({ page: 1, search: searchQuery });
      setPaginationModel({ ...paginationModel, page: 0 });
      setIsRadioChange(false);
    }
  };

  const handlePaginationModelChange = (model) => {
    setPaginationModel(model);
    setSearchParams({ page: model.page + 1, search: searchQuery });
    setQueryOptions({ ...queryOptions, pageSize: model.pageSize });
  };

  useEffect(() => {
    const page = Number(searchParams.get("page")) - 1 || 0;
    setPaginationModel((prev) => ({ ...prev, page }));
  }, [searchParams]);

  const handleFilterReset = () => {
    setTextFields({});
    setRadioValues({});
    setCheckboxValues({});
    setCheckedCount(0);
    setNewCount(0);
    setIsBulkUpload(0);
    sessionStorage.setItem("selectedCount", 0);
    const a = quesAnsArrayFilter.map((q) => ({
      type_id: q.type_id,
      question_id: q.question_id,
      ans_text: "",
      errorText: null,
      operator: "=",
      isChecked: false,
    }));
    setrefreshagain(true);
    setQuesAnsArrayFilter(a);
    setIsReset(true);
    setCurrent(a);
    setAdvanceFilter(false);
    setFilterHitting(false);
    setSearchParams({ page: 1 });
    sessionStorage.removeItem("selectedViewNameApplied");
    sessionStorage.removeItem("selectedOptionsApplied");
    sessionStorage.removeItem("selectedCountApplied");
    sessionStorage.removeItem("createdbyApplied");
    setSelectedOptions([]);
    sessionStorage.removeItem("selectedOptions");
    setCreatedby("");
    sessionStorage.removeItem("createdby");
    setSelectedViewName(radioNames[0]);
    sessionStorage.setItem("selectedViewName", radioNames[0]);
  };

  const handleAddToJobOpen = () => setOpenAddtoJob(true);

  const selectedChipOption = () => {
    const sessionStorageOptions = sessionStorage.getItem("selectedOptions");
    return selectedOptions.length > 0
      ? selectedOptions
      : JSON.parse(sessionStorageOptions);
  };

  return (
    <div ref={containerRef} style={{ height: "100%" }}>
      {openAddtoJob && (
        <AddToJobBtn
          openAddtoJob={openAddtoJob}
          addToJobCandidateids={addToJobCandidateids}
          setOpenAddtoJob={setOpenAddtoJob}
          setSelectedRows={setSelectedRows}
          setAddToJobCandidateids={setAddToJobCandidateids}
          setRenderKey={setRenderKey}
        />
      )}

      {/* ── Hidden wrappers ── */}
      <Box sx={{ display: "none" }}>
        <span ref={newCandidateRef}>
          <NewAddCandidate
            isAddToJob={false}
            setrefreshagain={setrefreshagain}
          />
        </span>
        <span ref={bulkCandidateRef}>
          <AddBulkCandidates
            pollStatus={pollStatus}
            setUploadProgress={setUploadProgress}
            setUploadingFiles={setUploadingFiles}
            setUploadPanelOpen={setUploadPanelOpen}
            setProcessedFiles={setProcessedFiles}
            isProcessing={isProcessing}
            setIsProcessing={setIsProcessing}
          />
        </span>
      </Box>

      <Box className="pageWrapper">
        {/* ── Toolbar ── */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // mb: 1,
          }}
        >
          {/* LEFT: Title */}
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, fontSize: "18px", color: "#151D48" }}
          >
            Manage Candidates
          </Typography>

          {/* RIGHT: Search + Buttons */}
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {/* Search */}
            <TextField
              variant="outlined"
              placeholder="Search"
              size="small"
              value={searchQuery}
              onChange={handleSearch}
              sx={{
                width: "200px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  fontSize: "14px",
                  height: "32px",
                  "& fieldset": { borderColor: "#D0D5DD" },
                  "&:hover fieldset": { borderColor: "#3F95EA" },
                  "&.Mui-focused fieldset": { borderColor: "#3F95EA" },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ fontSize: "18px", color: "#667085" }} />
                  </InputAdornment>
                ),
              }}
            />

            {/* Add to Job */}
            {addCandidatePermission?.add === 1 && (
              <Button
                variant="contained"
                disabled={
                  selectedRows.length === 0 || selectedRows.length >= 11
                }
                onClick={handleAddToJobOpen}
                startIcon={<AddIcon />}
                sx={{
                  height: "32px",
                  borderRadius: "8px",
                  textTransform: "uppercase",
                  fontWeight: 500,
                  fontSize: "14px",
                  px: 2,
                  backgroundColor: "#3F95EA",
                  "&:hover": { backgroundColor: "#3585d4" },
                  "&.Mui-disabled": {
                    backgroundColor: "#3F95EA",
                    opacity: 0.5,
                    color: "#fff",
                    height: "32px",
                  },
                }}
              >
                Add to Job
              </Button>
            )}

            {/* Add Candidate split button */}
            {addCandidatePermission?.add === 1 && (
              <Box
                sx={{ display: "flex", alignItems: "stretch", height: "32px" }}
              >
                <Button
                  variant="contained"
                  sx={{
                    height: "32px",
                    borderRadius: "8px 0 0 8px",
                    textTransform: "uppercase",
                    fontWeight: 500,
                    fontSize: "14px",
                    px: 2,
                    backgroundColor: "#3F95EA",
                    "&:hover": { backgroundColor: "#3585d4" },
                  }}
                  onClick={() =>
                    newCandidateRef.current?.querySelector("button")?.click()
                  }
                >
                  Add Candidates
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    height: "32px",
                    borderRadius: "0 8px 8px 0",
                    borderLeft: "1px solid rgba(255,255,255,0.4)",
                    minWidth: "32px",
                    px: 0.5,
                    backgroundColor: "#006CB7",
                    "&:hover": { backgroundColor: "#005a9e" },
                  }}
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                >
                  <ArrowDropDownIcon />
                </Button>
              </Box>
            )}

            <Menu
              anchorEl={anchorEl}
              open={dropdownOpen}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  mt: "4px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                  minWidth: "160px",
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  bulkCandidateRef.current?.querySelector("button")?.click();
                }}
                sx={{
                  fontSize: "13px",
                  "&:hover": {
                    backgroundColor: "rgb(227, 242, 253)",
                    color: "#1565C0",
                  },
                }}
              >
                Add Bulk Candidates
              </MenuItem>
            </Menu>

            {/* ── Filter button — position:relative so AdvanceFilter dropdown anchors here ── */}
            <Box sx={{ position: "relative" }}>
              <Button
                variant="outlined"
                onClick={handleAdvanceFilterOpen}
                startIcon={<img src="/assets/filter.svg" />}
                sx={{
                  height: "32px",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "14px",
                  borderColor: "#D0D5DD",
                  color: "#344054",
                  backgroundColor: "#fff",
                  "&:hover": {
                    borderColor: "#344054",
                    backgroundColor: "#F5FAFF",
                    height: "32px",
                  },
                }}
                endIcon={
                  sessionStorage.getItem("selectedCount") > 0 ? (
                    <Box
                      sx={{
                        background: "#3b82f6",
                        color: "#fff",
                        borderRadius: "50%",
                        minWidth: 18,
                        height: 18,
                        fontSize: "11px !important",
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        px: 0.4,
                      }}
                    >
                      {sessionStorage.getItem("selectedCount")}
                    </Box>
                  ) : null
                }
              >
                Filter
              </Button>

              {/* AdvanceFilter dropdown — inside position:relative Box */}
              <AdvanceFilter
                viewCandidateFlag={viewCandidateFlag}
                selectedViewName={
                  sessionStorage.getItem("selectedViewName") || radioNames[0]
                }
                handleViewCandidateBy={handleViewCandidateBy}
                isRadioChange={isRadioChange}
                radioNames={radioNames}
                isBulkUpload={isBulkUpload}
                handleBulkUploadChange={handleBulkUploadChange}
                advanceFilter={advanceFilter}
                handleAdvanceFilterOpen={handleAdvanceFilterOpen}
                handleAdvanceFilterClose={handleAdvanceFilterClose}
                handleAdvanceFilterApply={handleAdvanceFilterApply}
                handleFilterReset={handleFilterReset}
                question={question}
                setQuestion={setQuestion}
                textFields={textFields}
                radioValues={radioValues}
                operatorValues={operatorValues}
                checkboxValues={checkboxValues}
                quesAnsArrayFilter={quesAnsArrayFilter}
                selectedCount={sessionStorage.getItem("selectedCount") || 0}
                selectedOptions={selectedChipOption()}
                handleSelectionData={handleSelectionData}
                candidateList={candidateList}
                username={username}
                setCurrent={setCurrent}
              />
            </Box>
          </Box>
        </Box>

        {warning && (
          <Typography
            variant="body1"
            textAlign="center"
            color="error"
            sx={{ mb: 1 }}
          >
            You cannot select more than 10 Candidates.
          </Typography>
        )}

        {/* ── Table ── */}
        <Box
          sx={{
            height: "100%",
            overflowY: "hidden",
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <DynamicDataGrid
            rows={ManageCandidates}
            loading={showLoader}
            showCheckbox={addCandidatePermission?.add === 1}
            name={"ManageCandidates"}
            onRowSelection={HandleRowClick}
            onRowSelectionModelChange={handleRowSelection}
            rowSelectionModel={selectedRows}
            totalRows={totalCount}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationModelChange}
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
          />
        </Box>
      </Box>
    </div>
  );
}

export default ManageCandidate;
